export default __webpack_public_path__ + "static/media/shuffle.010d23ab.svg";